import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useLocation } from 'react-router-dom'
import { getUsersCards } from 'services/withDraw'

export default function useGetCards(
    id: undefined | number,
    userId: number | undefined,
    setSelectedBankNumber: React.Dispatch<React.SetStateAction<number>>
) {
    const [activeAccount, setActiveAccount] = useState<
        IBankAccountCards | undefined
    >()
    const [activeAccounts, setActiveAccounts] = useState<
        IBankAccountCards[] | undefined
    >()
    const [otherAccounts, setOtherAccounts] = useState<
        IBankAccountCards[] | undefined
    >()
    const [reallySelectedCard, setReallySelectedCard] = useState<
        IBankAccountCards | undefined
    >()
    const { state } = useLocation()
    // console.log('state', state)
    const { data, isLoading } = useQuery(
        ['init-payment-os-wallet-cards', id],
        getUsersCards
    )
    useEffect(() => {
        if (!isLoading && data && data.receivers) {
            // console.log('data', data)
            const findUser = data.receivers[0].bankaccounts.find(
                (item) => item.member === userId && item.is_default
            )
            findUser && setSelectedBankNumber(findUser.id)
            setActiveAccount(findUser)
            const findActiveAccounts: IBankAccountCards[] = []
            const findOtherAccounts: IBankAccountCards[] = []
            data.receivers[0].bankaccounts.map((item) => {
                if (state.selectedCardNumber) {
                    if (item.id === state.selectedCardNumber) {
                        findActiveAccounts.push({
                            ...item,
                            isSelected: true,
                        })
                        setReallySelectedCard({ ...item, isSelected: true })
                    } else {
                        findActiveAccounts.push({
                            ...item,
                            isSelected: false,
                        })
                    }
                } else {
                    if (item.member === userId) {
                        if (item.is_default) {
                            findActiveAccounts.push({
                                ...item,
                                isSelected: true,
                            })
                            setReallySelectedCard({ ...item, isSelected: true })
                        } else {
                            findActiveAccounts.push({
                                ...item,
                                isSelected: false,
                            })
                        }
                    } else {
                        findOtherAccounts.push({ ...item, isSelected: false })
                    }
                }
            })
            setActiveAccounts(findActiveAccounts)
            setOtherAccounts(findOtherAccounts)
        }
    }, [data])
    const handleSelectCard = (id: number) => {
        const findActiveAccounts: IBankAccountCards[] = []
        const findOtherAccounts: IBankAccountCards[] = []
        data &&
            data.receivers[0].bankaccounts.map((item) => {
                if (item.member === userId) {
                    if (item.id === id) {
                        findActiveAccounts.push({ ...item, isSelected: true })
                        setReallySelectedCard({ ...item, isSelected: true })
                    } else {
                        findActiveAccounts.push({ ...item, isSelected: false })
                    }
                } else {
                    if (item.id === id) {
                        findOtherAccounts.push({ ...item, isSelected: true })
                        setReallySelectedCard({ ...item, isSelected: true })
                    } else {
                        findOtherAccounts.push({ ...item, isSelected: false })
                    }
                }
            })
        setActiveAccounts(findActiveAccounts)
        setOtherAccounts(findOtherAccounts)
    }
    return {
        data,
        isLoading,
        activeAccount,
        activeAccounts,
        otherAccounts,
        handleSelectCard,
        reallySelectedCard,
    }
}
